import { FieldAttributes } from 'formik';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { URL_PLACEHOLDER } from 'constants/common.constants';
import { TranslationNamespace } from 'i18n';
import { validationUtils } from 'utils';

import { FormikTextField } from '../FormikTextField';

type Props = FieldAttributes<any> & {
  allowLocalhost?: boolean;
};

// Text field for URL input that validates the value on its own, so a form schema only needs to
// handle `required`.
// TODO: replace all URL inputs in the app with this component (shop webSiteUrl, order callbackUrl,
// P2P provider url, deeplink url, telegramSupportBotUrl, etc.). Check existing values first:
// most of those fields were never validated and may hold URLs without a scheme.
export const FormikUrlTextField: React.FC<Props> = ({
  allowLocalhost = true,
  validate,
  ...props
}) => {
  const { t } = useTranslation(TranslationNamespace.Common);

  const validateUrl = useCallback(
    (value?: string) => {
      if (validationUtils.isUrl(value, { allowLocalhost })) {
        return validate?.(value);
      }
      // Tell the user to add the scheme only when that alone fixes the value
      return validationUtils.isUrl(`http://${value}`, { allowLocalhost })
        ? t('errors.url_missing_protocol')
        : t('errors.invalid_url');
    },
    [t, allowLocalhost, validate],
  );

  return (
    <FormikTextField
      placeholder={URL_PLACEHOLDER}
      {...props}
      validate={validateUrl}
    />
  );
};
